import { render, staticRenderFns } from "./pickUp.vue?vue&type=template&id=49458c90&scoped=true&"
import script from "./pickUp.vue?vue&type=script&lang=js&"
export * from "./pickUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49458c90",
  null
  
)

export default component.exports